import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withKeys as _withKeys, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-11d3ac14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "organisation-picker" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = {
  class: "list-container",
  ref: "list"
}
const _hoisted_5 = ["onClick", "onKeydown"]

import { computed, onMounted, ref } from "vue";

import { OrganisationDescriptionApiModel } from "../../../api-models";


export default /*#__PURE__*/_defineComponent({
  __name: 'organisation-picker',
  props: {
    organisations: {},
    selection: {}
  },
  emits: ["selection-changed"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const searchText = ref("");

const filteredOrganisations = computed(() => {
  if (!searchText.value) {
    return props.organisations;
  }

  const filtered = props.organisations.filter((o) =>
    o.name.toLowerCase().includes(searchText.value),
  );
  filtered.sort((a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  });

  if (!!props.selection && !filtered.includes(props.selection)) {
    emit("selection-changed", null);
  }

  return filtered;
});

const selectOrganisation = (newSelection: OrganisationDescriptionApiModel | null): void => {
  emit("selection-changed", newSelection);
};

onMounted(() => {
  emit("selection-changed", null);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "search",
        class: "form-control",
        placeholder: "Search...",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
        "aria-label": "Search organisations"
      }, null, 512), [
        [_vModelText, searchText.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOrganisations.value, (organisation) => {
          return (_openBlock(), _createElementBlock("div", {
            key: organisation.id,
            class: _normalizeClass(["list-item", { selected: organisation === _ctx.selection }])
          }, [
            _createElementVNode("span", {
              onClick: ($event: any) => (selectOrganisation(organisation)),
              onKeydown: _withKeys(($event: any) => (selectOrganisation(organisation)), ["enter"])
            }, _toDisplayString(organisation.name), 41, _hoisted_5)
          ], 2))
        }), 128))
      ], 512)
    ])
  ]))
}
}

})